import { app } from "./app";
import { fabric } from "./fabric";
import URL from "url-parse";
import getYoutubeId from "get-youtube-id";
import aes from "./sjcl";
import { loadFonts } from "./fonts";
import ClipboardJS from "clipboard";
import axios from "axios";

// clipboard
let clipboard = new ClipboardJS(".cpy-img-btn");
clipboard.on("success", function (e) {
  app.ports.fromBrowser.send({
    event: "IMAGE_URL_COPIED",
    payload: e.text,
  });
});

var aesKey = "VnEB2299JVhK9Uzp";

function encrypt(input) {
  return aes.encrypt(aesKey, input);
}

function decrypt(input) {
  return aes.decrypt(aesKey, input);
}

class UserInactivityWatchdog {
  constructor() {
    this.userInactivityEvents = [
      "mousemove",
      "keypress",
      "scroll",
      "touchmove",
      "touchstart",
      "click",
      "contextmenu",
      "keydown",
    ];
    this.userInactivityTimeout = 60 * 60 * 1000;
    this.inactivityTimer = null;

    // bind this
    this.startTimer = this.startTimer.bind(this);
    this.clearTimer = this.clearTimer.bind(this);
    this.addEventListeners = this.addEventListeners.bind(this);
    this.removeEventListeners = this.removeEventListeners.bind(this);
    this.resetTimer = this.resetTimer.bind(this);
    this.sendEvent = this.sendEvent.bind(this);
  }

  startTimer() {
    this.addEventListeners();
    this.resetTimer();
  }

  resetTimer() {
    clearTimeout(this.inactivityTimer);
    this.inactivityTimer = setTimeout(
      this.sendEvent,
      this.userInactivityTimeout
    );
  }

  clearTimer() {
    this.removeEventListeners();
    clearTimeout(this.inactivityTimer);
  }

  addEventListeners() {
    this.userInactivityEvents.forEach((e) => {
      document.addEventListener(e, this.resetTimer);
    });
  }

  removeEventListeners() {
    this.userInactivityEvents.forEach((e) => {
      document.removeEventListener(e, this.resetTimer);
    });
  }

  sendEvent() {
    app.ports.fromBrowser.send({
      event: "USER_INACTIVE",
    });
  }
}
let userInactivityWatchdog = new UserInactivityWatchdog();

app.ports.toBrowser.subscribe(({ event, payload }) => {
  if (process.env.NODE_ENV === "development") {
    console.log("[admin -> browser]", event, payload);
  }

  switch (event) {
    case "SCROLL_TO_TOP":
      window.scrollTo(0, 0);
      break;

    case "INIT_WATCHDOG":
      userInactivityWatchdog.startTimer();
      break;

    case "LOGOUT_USER":
      /* global localStorage, location */
      localStorage.removeItem("userInf");
      fabric.disconnect();
      userInactivityWatchdog.clearTimer();
      location.reload(true);
      break;

    case "RESET_CONNECTION":
      fabric.connect();
      break;

    case "OPEN_SIDEBAR":
      app.ports.fromBrowser.send({
        event: "OPEN_SIDEBAR",
      });
      break;

    case "CLOSE_SIDEBAR":
      app.ports.fromBrowser.send({
        event: "CLOSE_SIDEBAR",
      });
      break;

    case "GET_YOUTUBE_ID":
      parseYoutubeUrl(payload);
      break;

    case "LOAD_FONTS":
      loadFonts(payload);
      break;

    case "SET_USER_STATE":
      localStorage.setItem("userInf", encrypt(JSON.stringify(payload)));
      break;

    case "GET_USER_STATE":
      let userInfo = localStorage.getItem("userInf");
      if (userInfo) {
        /* global requestAnimationFrame */
        requestAnimationFrame(() => {
          app.ports.fromBrowser.send({
            event: "USER_STATE_FROM_STORAGE",
            payload: JSON.parse(decrypt(userInfo)),
          });
        });
      } else {
        // do nothing
      }
      break;

    case "OPEN_MEDIA_LIBRARY":
      app.ports.fromBrowser.send({
        event: "OPEN_MEDIA_LIBRARY",
        payload: payload,
      });
      break;

    case "COPY_MEDIA_IMG":
      break;

    case "SET_STORED_VERSION":
      localStorage.setItem("version", payload);
      break;

    case "GET_STORED_VERSION":
      app.ports.fromBrowser.send({
        event: "RESP_STORED_VERSION",
        version: localStorage.getItem("version"),
      });
      console.log(localStorage.getItem("version"));
      break;

    case "SHOW_GLOBAL_TOAST":
      app.ports.fromBrowser.send({
        event: "SHOW_GLOBAL_TOAST",
        message: payload,
      });
      break;

    case "PARSE_EXPIRY_DATE":
      app.ports.fromBrowser.send({
        event: "PARSED_EXPIRY_DATE",
        payload: new Date(payload).toISOString(),
      });
      break;
  }
});

function parseYoutubeUrl(data) {
  // parse playlist
  const getYoutubePlaylistId = (rawUrl) => {
    let parsedUrl = new URL(rawUrl, true);
    return parsedUrl.query.list || null;
  };
  const isNull = (val) => val == null;

  let youtubeVideoId = getYoutubeId(data.url);
  let playlistId = getYoutubePlaylistId(data.url);

  if (!isNull(youtubeVideoId)) {
    app.ports.fromBrowser.send({
      event: "YOUTUBE_VIDEO_ID_SUCCESS",
      videoId: youtubeVideoId,
      style: data.style,
      widgetId: data.widgetId,
    });
  } else if (!isNull(playlistId)) {
    app.ports.fromBrowser.send({
      event: "YOUTUBE_PLAYLIST_SUCCESS",
      playlistId: playlistId,
      widgetId: data.widgetId,
      style: data.style,
    });
  } else {
    app.ports.fromBrowser.send({
      event: "YOUTUBE_PARSE_FAIL",
    });
  }
}

/** global FormData */

/** Upload an image file
 * https://www.paramander.com/blog/using-ports-to-deal-with-files-in-elm-0-17
 */
app.ports.uploadImage.subscribe(function (config) {
  if (process.env.NODE_ENV === "development") {
    console.log("[admin -> upload]", config);
  }

  let { divId, accessToken, imageAddr } = config;
  let baseUrl = imageAddr[0];
  let districtId = imageAddr[1];

  if (baseUrl && accessToken && divId) {
    var node = document.getElementById(divId);
    if (node === null) {
      app.ports.fromBrowser.send({
        event: "IMAGE_UPLOAD_FAIL",
        msg: "Div not available",
      });
      return;
    }
    var file = node.files[0];
    
    if(file.size<=512000){ //Check 512KB Image size
    var formData = new FormData();
    formData.append("id", districtId);
    formData.append("image", file);

    axios
      .post(baseUrl + "/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          authorization: accessToken,
        },
      })
      .then((resp) => {
        app.ports.fromBrowser.send({
          event: "IMAGE_UPLOAD_SUCCESS",
          msg: file.name,
        });
      })
      .catch((err) => {
        app.ports.fromBrowser.send({
          event: "IMAGE_UPLOAD_FAIL",
          msg: "Server error",
          err,
        });
      });
    }else{
      app.ports.fromBrowser.send({
        event: "IMAGE_UPLOAD_FAIL",
        msg: "Please select less than or equal 512 KB"
      });
      window.alert("Please select less than or equal 512 KB")
      return false
    }

  } else {
    app.ports.fromBrowser.send({
      event: "IMAGE_UPLOAD_FAIL",
      msg: "Incorrect data provided",
    });
  }
});


app.ports.uploadDesignImage.subscribe(function (config) {
  if (process.env.NODE_ENV === "development") {
    console.log("[admin -> upload]", config);
  }

  let { divId, accessToken, imageAddr } = config;
  let baseUrl = imageAddr[0];
  let districtId = imageAddr[1];

  if (baseUrl && accessToken && divId) {
    var node = document.getElementById(divId);
    if (node === null) {
      app.ports.fromBrowser.send({
        event: "IMAGE_UPLOAD_FAIL",
        msg: "Div not available",
      });
      return;
    }
    var file = node.files[0];
    if(file.size<=512000){ //Check 512KB Image size
    var newFileName =file.name.replace(/[^a-zA-Z0-9.]/g, "_");
    //Todo : Please don't remove it 
    // Renaming File Name
    // let dateTime = new Date().getTime();;
    // let file_name_array= newFileName.split(".")
    //  newFileName =file_name_array[0]+'_'+dateTime.toString()+'.'+file_name_array[1]
    var newFile = new File([file], newFileName, {
      type: file.type,
    });
    // Generrate FormData
    var formData = new FormData();   
    formData.append("id", districtId);
    formData.append("image", newFile);
    // Uploading Image
    axios
      .post(baseUrl + "/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          authorization: accessToken,
        },
      })
      .then((resp) => {
        app.ports.fromBrowser.send({
          event: "IMAGE_UPLOAD_SUCCESS",
          msg: newFileName,
        });
      })
      .catch((err) => {
        app.ports.fromBrowser.send({
          event: "IMAGE_UPLOAD_FAIL",
          msg: "Server error",
          err,
        });
      });
    }else{
      app.ports.fromBrowser.send({
        event: "IMAGE_UPLOAD_FAIL",
        msg: "Please select less than or equal 512 KB"
      });
      window.alert("Please select less than or equal 512 KB")
      return false
    }
  } else {
    app.ports.fromBrowser.send({
      event: "IMAGE_UPLOAD_FAIL",
      msg: "Incorrect data provided",
    });
  }
});